// src/pages/beta-community/components/HeroSection.jsx
import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = ({ scrollToSection }) => {
  return (
    <section className="hero-section">
      <div className="container">
        {/* Logo animé */}
        <motion.h1
          className="hero-logo"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          ARTKIV
        </motion.h1>

        {/* Tagline */}
        <motion.p
          className="hero-tagline"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
        >
          Beta Community
        </motion.p>

        {/* Titre principal */}
        <motion.h2
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        >
          Testez ARTKIV avec les premiers utilisateurs fondateurs
        </motion.h2>

        {/* Sous-titre */}
        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
        >
          Un accès bêta pour collectionneurs, Art Advisors, Family Offices et CGP qui veulent tester la gestion intelligente des collections avant le lancement public
        </motion.p>

        {/* Boutons CTA */}
        <motion.div
          className="hero-cta-group"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
        >
          <button
            className="btn btn-primary"
            onClick={() => scrollToSection('inscription')}
          >
            Rejoindre la Beta Community
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => scrollToSection('demo')}
          >
            Comprendre le parcours
          </button>
        </motion.div>
      </div>

      {/* Gradient décoratif */}
      <div className="hero-gradient"></div>
    </section>
  );
};

export default HeroSection;